App.factory('responseHelper', (toaster, $state, authService, $rootScope) => ({
  redirectOrToastOnResp(response, successUri, errorUri, successUriParams = {}, successUriReload = false, errorUriParams = {}, error_timeout = 5000) {
    if(response.$response.status === 200){
      if (response.$response.data.code === true){
        this.toasterResponse(response.$response.data.description, 'success', 'Success')
        if(successUri != undefined){
          if(_.isObject(successUri) === true){
            $state.go(...successUri)
          } else{
            $state.go(successUri, successUriParams, {reload: successUriReload})
          }
        }
        return true
      }
      else if(response.$response.data.code === false){
        this.toasterResponse(this.errMsg(response), 'error', 'Error', error_timeout)
        if(errorUri != undefined){
          $state.go(errorUri, errorUriParams)
        }
        return false
      }
      else{
        return false
      }
    }
    else if([403, 404].indexOf(response.$response.status) !== -1){
      this.toasterResponse(this.errMsg(response), 'error', 'Error')
      return false
    }
    else if(response.$response.status === 422){
      this.toasterResponse(this.errMsg(response), 'warning', 'Error')
      if(errorUri != undefined){
        $state.go(errorUri, errorUriParams)
      }
      return false
    }
    else if(response.$response.status === 304){

    }
    else if(response.$response.status >= 500){
      toaster.pop('error', 'Error', 'Server error, please contact us.')
      return false
    }
    else if(response.$response.status === 401){
      this.toasterResponse(this.errMsg(response), 'error', 'Error')
      const { redirectAfterLogoutUrl } = authService.willUnauthorizeUser()
      window.location.href = redirectAfterLogoutUrl
      return false
    }
    else{

    }
  },

  // "impersonationSessionId" used for backward compatibility with the old backend. should be removed once we use Auth::Token for auth
  willStoreCookie(response, impersonationSessionId = null) {
    const data = response.$response.data.data
    if (response.$response.data.code === true){
      if(response.utype == 'Patient'){
        this.redirectOrToastOnResp(response, nil)
        // $location.url('/')
      } else {
        authService.willAuthorizeUser(data.user, data.uid_hash, data.subdomain, data.institution, data.remember_token, data.location_id, impersonationSessionId)
        // data.user.meta_type, data.user.id, data.user.name, data.subdomain, data.user.profile_url, data.user.min_appt_length, data.user.patientable)
        $rootScope.user.id = data.user.id
        $rootScope.user.meta_type = data.user.meta_type
        $rootScope.user.picture = data.user.profile_url
        $rootScope.user.name = data.user.name
        $rootScope.user.email = data.user.email
        $rootScope.user.title = data.user.meta_type
        $rootScope.user.min_appt_length = data.user.min_appt_length
      }
    }
    else{
      this.redirectOrToastOnResp(response)
    }
  },

  checkError(response, error_message = null) {
    if (response.status === 404){
      toaster.pop('error', 'Record not found')
    }
    else if(response.status === 401){
      $rootScope.logOut()
    }
    else if(status.code >= 500 || response.status >= 500){
      toaster.pop('error', 'Internal server error.')
    }
    else if(response.xhrStatus == 'error' || response.xhrStatus == 'abort'){
      error_message = error_message || 'We’ve encountered an issue, please try refreshing the page'
      this.toasterResponse(error_message, 'error', 'Error(timeout)', 0)
    }
  },

  errMsg(response) {
    if(response.$response.data.error && response.$response.data.error.length){
      return response.$response.data.error
    } else {
      return response.$response.data.description
    }
  },

  toasterResponse(obj, type, header, timeout=5000) {
    if(obj){
      if(angular.isArray(obj)){
        obj.forEach(item => {
          if(item) {
            toaster.pop({type: type, title: header, body: item, bodyOutputType: 'trustedHtml', timeout: timeout})
          }
        })
      } else {
        toaster.pop({type: type, title: header, body: obj, bodyOutputType: 'trustedHtml', timeout: timeout})
      }
    }
  }
}))
